import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { DataGrid } from '@mui/x-data-grid';
import { daDK } from '@mui/x-data-grid/locales';

import nbNO from '@mui/x-data-grid/locales/nbNO';
import * as XLSX from 'xlsx';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const BDAutoexcluidos = () => {
  const [autoexcluidos, setAutoexcluidos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const url = 'https://us-central1-inprojuy-f1173.cloudfunctions.net/app/autoexcluidost';

    axios.get(url)
      .then((response) => {
        setAutoexcluidos(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error('Error al obtener los datos de autoexcluidos:', error);
        setLoading(false);
      });
  }, []);

  const columns = [
    { field: 'id', headerName: 'ID ', width: 130 },
    { field: 'nombre', headerName: 'Nombre', width: 130 },
    { field: 'fechaNacimiento', headerName: 'Fecha de Nacimiento', width: 180 },
    { field: 'vencimiento', headerName: 'Vencimiento', width: 180 },
    { field: 'dni', headerName: 'DNI', width: 130 },
    { field: 'telefono', headerName: 'Teléfono', width: 130 },
    // Agrega más columnas según tus necesidades
  ];

  const getRowId = (row) => row.dni; // Utiliza un campo único como ID, ajusta según tus datos

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(autoexcluidos);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Autoexcluidos');
    XLSX.writeFile(wb, 'autoexcluidos.xlsx');
  };

  return (
    <Container style={{ height: 650, width: '100%' }}>
      <div style={{ height: 500, width: '100%' }}>
        <center><h2>Base de Datos de Autoexcluidos</h2></center>
        <button onClick={exportToExcel}>Exportar a Excel</button> <a></a>
        <p></p>

        {loading ? (
          <div id="load">
            <div>O</div>
            <div>D</div>
            <div>N</div>
            <div>A</div>
            <div>G</div>
            <div>R</div>
            <div>A</div>
            <div>C</div>
          </div>
        ) : (
          <DataGrid
            rows={autoexcluidos}
            columns={columns}
            pageSize={pageSize}
            pagination
            onPageChange={(params) => {
              setCurrentPage(params.page);
            }}
            onPageSizeChange={(params) => {
              setPageSize(params.pageSize);
            }}
            getRowId={getRowId} // Agrega esta línea para especificar cómo obtener el id
          />
        )}
      </div>
    </Container>
  );
};

export default BDAutoexcluidos;
